<template>
    <div class="flex flex-col items-start">
        <p class="text-left">{{ nome_utente }}</p>
        <p class="text-left text-sm text-slate-600" v-if="nome_utente && nome_utente.trim() != ''">{{ nome_contratto }}</p>
    </div>
</template>
<script>
export default{
    name: 'UtenteTicketDatatable',
    props:[
        'nome_utente',
        'nome_contratto'
    ]
}
</script>